import { useCallback } from 'react';

import { DatadogContextType } from '../types/datadog/datadog';
import { datadogRum } from '@datadog/browser-rum';
import { coalesceError } from '~/lib/common/coalesceError';

export const useDatadog = (): DatadogContextType => {
  const setCurrentUserId = useCallback((userId: string) => {
    datadogRum.setUser({ id: userId });
  }, []);

  const addUserAction = useCallback(
    (name: string, context?: Record<string, unknown>) =>
      datadogRum.addAction(name, context),
    [],
  );

  const logError = useCallback(
    (maybeError: unknown, context?: Record<string, unknown>) => {
      // any type in javascript may be thrown - safely coalesce to error object
      const error = coalesceError(maybeError);
      datadogRum.addError(error, context);
    },
    [],
  );

  const setAttribute = useCallback(
    (key: string, value: unknown) =>
      datadogRum.setGlobalContextProperty(key, value),
    [],
  );

  const removeAttribute = useCallback(
    (key: string) => datadogRum.removeGlobalContextProperty(key),
    [],
  );

  return {
    addUserAction,
    logError,
    removeAttribute,
    setAttribute,
    setCurrentUserId,
  };
};
